"use client";
import "../../chunk-MMUBH76A.js";
var ModalStep = /* @__PURE__ */ ((ModalStep2) => {
  ModalStep2["AUTH_MAIN"] = "AUTH_MAIN";
  ModalStep2["AUTH_MORE"] = "AUTH_MORE";
  ModalStep2["EX_WALLET_MORE"] = "EX_WALLET_MORE";
  ModalStep2["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
  ModalStep2["VERIFICATIONS"] = "VERIFICATIONS";
  ModalStep2["AWAITING_OAUTH"] = "AWAITING_OAUTH";
  ModalStep2["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
  ModalStep2["BIOMETRIC_CREATION"] = "BIOMETRIC_CREATION";
  ModalStep2["AWAITING_BIOMETRIC_CREATION"] = "AWAITING_BIOMETRIC_CREATION";
  ModalStep2["PASSWORD_CREATION"] = "PASSWORD_CREATION";
  ModalStep2["AWAITING_PASSWORD_CREATION"] = "AWAITING_PASSWORD_CREATION";
  ModalStep2["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
  ModalStep2["TELEGRAM_OAUTH"] = "TELEGRAM_OAUTH";
  ModalStep2["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
  ModalStep2["SECRET"] = "SECRET";
  ModalStep2["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
  ModalStep2["AWAITING_BIOMETRIC_LOGIN"] = "AWAITING_BIOMETRIC_LOGIN";
  ModalStep2["AWAITING_PASSWORD_LOGIN"] = "AWAITING_PASSWORD_LOGIN";
  ModalStep2["LOGIN_DONE"] = "LOGIN_DONE";
  ModalStep2["SETUP_2FA"] = "SETUP_2FA";
  ModalStep2["VERIFY_2FA"] = "VERIFY_2FA";
  ModalStep2["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
  ModalStep2["ADD_FUNDS_BUY"] = "ADD_FUNDS_BUY";
  ModalStep2["ADD_FUNDS_RECEIVE"] = "ADD_FUNDS_RECEIVE";
  ModalStep2["ADD_FUNDS_WITHDRAW"] = "ADD_FUNDS_WITHDRAW";
  ModalStep2["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
  ModalStep2["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
  ModalStep2["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
  ModalStep2["ACCOUNT_MAIN"] = "ACCOUNT_MAIN";
  ModalStep2["CHAIN_SWITCH"] = "CHAIN_SWITCH";
  return ModalStep2;
})(ModalStep || {});
var AccountStep = /* @__PURE__ */ ((AccountStep2) => {
  AccountStep2["ACCOUNT_MAIN"] = "ACCOUNT_MAIN";
  AccountStep2["ADD_FUNDS_BUY"] = "ADD_FUNDS_BUY";
  AccountStep2["ADD_FUNDS_RECEIVE"] = "ADD_FUNDS_RECEIVE";
  AccountStep2["ADD_FUNDS_WITHDRAW"] = "ADD_FUNDS_WITHDRAW";
  AccountStep2["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
  AccountStep2["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
  AccountStep2["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
  AccountStep2["CHAIN_SWITCH"] = "CHAIN_SWITCH";
  return AccountStep2;
})(AccountStep || {});
const RESET_TO_AUTH_STEPS = [
  "EX_WALLET_MORE" /* EX_WALLET_MORE */,
  "EX_WALLET_SELECTED" /* EX_WALLET_SELECTED */,
  "VERIFICATIONS" /* VERIFICATIONS */,
  "AWAITING_OAUTH" /* AWAITING_OAUTH */,
  "FARCASTER_OAUTH" /* FARCASTER_OAUTH */,
  "TELEGRAM_OAUTH" /* TELEGRAM_OAUTH */,
  "BIOMETRIC_CREATION" /* BIOMETRIC_CREATION */,
  "AWAITING_BIOMETRIC_CREATION" /* AWAITING_BIOMETRIC_CREATION */,
  "PASSWORD_CREATION" /* PASSWORD_CREATION */,
  "AWAITING_PASSWORD_CREATION" /* AWAITING_PASSWORD_CREATION */,
  "BIOMETRIC_LOGIN" /* BIOMETRIC_LOGIN */,
  "AWAITING_BIOMETRIC_LOGIN" /* AWAITING_BIOMETRIC_LOGIN */,
  "AWAITING_PASSWORD_LOGIN" /* AWAITING_PASSWORD_LOGIN */,
  "AWAITING_WALLET_CREATION" /* AWAITING_WALLET_CREATION */,
  "AWAITING_WALLET_CREATION" /* AWAITING_WALLET_CREATION */,
  "WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */,
  "SETUP_2FA" /* SETUP_2FA */,
  "VERIFY_2FA" /* VERIFY_2FA */,
  "TWO_FACTOR_DONE" /* TWO_FACTOR_DONE */,
  "LOGIN_DONE" /* LOGIN_DONE */
];
const RESET_TO_ACCOUNT_STEPS = [
  "ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */,
  "ADD_FUNDS_RECEIVE" /* ADD_FUNDS_RECEIVE */,
  "ADD_FUNDS_WITHDRAW" /* ADD_FUNDS_WITHDRAW */,
  "ADD_FUNDS_AWAITING" /* ADD_FUNDS_AWAITING */,
  "ADD_FUNDS_SUCCESS" /* ADD_FUNDS_SUCCESS */,
  "ADD_FUNDS_FAILURE" /* ADD_FUNDS_FAILURE */,
  "CHAIN_SWITCH" /* CHAIN_SWITCH */
];
const AccountPreviousStep = {
  ["ACCOUNT_MAIN" /* ACCOUNT_MAIN */]: void 0,
  ["ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */,
  ["ADD_FUNDS_WITHDRAW" /* ADD_FUNDS_WITHDRAW */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */,
  ["ADD_FUNDS_RECEIVE" /* ADD_FUNDS_RECEIVE */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */,
  ["ADD_FUNDS_AWAITING" /* ADD_FUNDS_AWAITING */]: "ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */,
  ["ADD_FUNDS_SUCCESS" /* ADD_FUNDS_SUCCESS */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */,
  ["ADD_FUNDS_FAILURE" /* ADD_FUNDS_FAILURE */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */,
  ["CHAIN_SWITCH" /* CHAIN_SWITCH */]: "ACCOUNT_MAIN" /* ACCOUNT_MAIN */
};
var SignUpModalStep = /* @__PURE__ */ ((SignUpModalStep2) => {
  SignUpModalStep2["AUTH_MAIN"] = "AUTH_MAIN";
  SignUpModalStep2["AUTH_MORE"] = "AUTH_MORE";
  SignUpModalStep2["EX_WALLET_MORE"] = "EX_WALLET_MORE";
  SignUpModalStep2["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
  SignUpModalStep2["VERIFICATIONS"] = "VERIFICATIONS";
  SignUpModalStep2["AWAITING_OAUTH"] = "AWAITING_OAUTH";
  SignUpModalStep2["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
  SignUpModalStep2["TELEGRAM_OAUTH"] = "TELEGRAM_OAUTH";
  SignUpModalStep2["BIOMETRIC_CREATION"] = "BIOMETRIC_CREATION";
  SignUpModalStep2["AWAITING_BIOMETRIC_CREATION"] = "AWAITING_BIOMETRIC_CREATION";
  SignUpModalStep2["PASSWORD_CREATION"] = "PASSWORD_CREATION";
  SignUpModalStep2["AWAITING_PASSWORD_CREATION"] = "AWAITING_PASSWORD_CREATION";
  SignUpModalStep2["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
  SignUpModalStep2["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
  SignUpModalStep2["SECRET"] = "SECRET";
  SignUpModalStep2["SETUP_2FA"] = "SETUP_2FA";
  SignUpModalStep2["VERIFY_2FA"] = "VERIFY_2FA";
  SignUpModalStep2["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
  SignUpModalStep2["ADD_FUNDS_BUY"] = "ADD_FUNDS_BUY";
  SignUpModalStep2["ADD_FUNDS_RECEIVE"] = "ADD_FUNDS_RECEIVE";
  SignUpModalStep2["ADD_FUNDS_WITHDRAW"] = "ADD_FUNDS_WITHDRAW";
  SignUpModalStep2["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
  SignUpModalStep2["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
  SignUpModalStep2["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
  return SignUpModalStep2;
})(SignUpModalStep || {});
const SignUpPreviousStep = {
  ["AUTH_MAIN" /* AUTH_MAIN */]: void 0,
  ["AUTH_MORE" /* AUTH_MORE */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["EX_WALLET_MORE" /* EX_WALLET_MORE */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["EX_WALLET_SELECTED" /* EX_WALLET_SELECTED */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["VERIFICATIONS" /* VERIFICATIONS */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["AWAITING_OAUTH" /* AWAITING_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["TELEGRAM_OAUTH" /* TELEGRAM_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["FARCASTER_OAUTH" /* FARCASTER_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["BIOMETRIC_CREATION" /* BIOMETRIC_CREATION */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["AWAITING_BIOMETRIC_CREATION" /* AWAITING_BIOMETRIC_CREATION */]: "BIOMETRIC_CREATION" /* BIOMETRIC_CREATION */,
  ["PASSWORD_CREATION" /* PASSWORD_CREATION */]: "BIOMETRIC_CREATION" /* BIOMETRIC_CREATION */,
  ["AWAITING_PASSWORD_CREATION" /* AWAITING_PASSWORD_CREATION */]: "BIOMETRIC_CREATION" /* BIOMETRIC_CREATION */,
  ["AWAITING_WALLET_CREATION" /* AWAITING_WALLET_CREATION */]: void 0,
  ["WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */]: void 0,
  ["SECRET" /* SECRET */]: void 0,
  ["SETUP_2FA" /* SETUP_2FA */]: "SECRET" /* SECRET */,
  ["VERIFY_2FA" /* VERIFY_2FA */]: "SETUP_2FA" /* SETUP_2FA */,
  ["TWO_FACTOR_DONE" /* TWO_FACTOR_DONE */]: void 0,
  ["ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */]: "WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */,
  ["ADD_FUNDS_RECEIVE" /* ADD_FUNDS_RECEIVE */]: "WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */,
  ["ADD_FUNDS_WITHDRAW" /* ADD_FUNDS_WITHDRAW */]: "WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */,
  ["ADD_FUNDS_AWAITING" /* ADD_FUNDS_AWAITING */]: "ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */,
  ["ADD_FUNDS_SUCCESS" /* ADD_FUNDS_SUCCESS */]: void 0,
  ["ADD_FUNDS_FAILURE" /* ADD_FUNDS_FAILURE */]: void 0
};
var LoginModalStep = /* @__PURE__ */ ((LoginModalStep2) => {
  LoginModalStep2["AUTH_MAIN"] = "AUTH_MAIN";
  LoginModalStep2["AUTH_MORE"] = "AUTH_MORE";
  LoginModalStep2["EX_WALLET_MORE"] = "EX_WALLET_MORE";
  LoginModalStep2["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
  LoginModalStep2["AWAITING_OAUTH"] = "AWAITING_OAUTH";
  LoginModalStep2["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
  LoginModalStep2["TELEGRAM_OAUTH"] = "TELEGRAM_OAUTH";
  LoginModalStep2["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
  LoginModalStep2["AWAITING_BIOMETRIC_LOGIN"] = "AWAITING_BIOMETRIC_LOGIN";
  LoginModalStep2["AWAITING_PASSWORD_LOGIN"] = "AWAITING_PASSWORD_LOGIN";
  LoginModalStep2["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
  LoginModalStep2["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
  LoginModalStep2["SECRET"] = "SECRET";
  LoginModalStep2["SETUP_2FA"] = "SETUP_2FA";
  LoginModalStep2["VERIFY_2FA"] = "VERIFY_2FA";
  LoginModalStep2["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
  LoginModalStep2["LOGIN_DONE"] = "LOGIN_DONE";
  LoginModalStep2["ADD_FUNDS_BUY"] = "ADD_FUNDS_BUY";
  LoginModalStep2["ADD_FUNDS_RECEIVE"] = "ADD_FUNDS_RECEIVE";
  LoginModalStep2["ADD_FUNDS_WITHDRAW"] = "ADD_FUNDS_WITHDRAW";
  LoginModalStep2["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
  LoginModalStep2["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
  LoginModalStep2["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
  return LoginModalStep2;
})(LoginModalStep || {});
const LoginPreviousStep = {
  ["AUTH_MAIN" /* AUTH_MAIN */]: void 0,
  ["AUTH_MORE" /* AUTH_MORE */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["EX_WALLET_MORE" /* EX_WALLET_MORE */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["EX_WALLET_SELECTED" /* EX_WALLET_SELECTED */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["TELEGRAM_OAUTH" /* TELEGRAM_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["AWAITING_OAUTH" /* AWAITING_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["FARCASTER_OAUTH" /* FARCASTER_OAUTH */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["BIOMETRIC_LOGIN" /* BIOMETRIC_LOGIN */]: "AUTH_MAIN" /* AUTH_MAIN */,
  ["AWAITING_BIOMETRIC_LOGIN" /* AWAITING_BIOMETRIC_LOGIN */]: "BIOMETRIC_LOGIN" /* BIOMETRIC_LOGIN */,
  ["AWAITING_PASSWORD_LOGIN" /* AWAITING_PASSWORD_LOGIN */]: "BIOMETRIC_LOGIN" /* BIOMETRIC_LOGIN */,
  ["AWAITING_WALLET_CREATION" /* AWAITING_WALLET_CREATION */]: void 0,
  ["WALLET_CREATION_DONE" /* WALLET_CREATION_DONE */]: void 0,
  ["SECRET" /* SECRET */]: void 0,
  ["SETUP_2FA" /* SETUP_2FA */]: void 0,
  ["VERIFY_2FA" /* VERIFY_2FA */]: "SETUP_2FA" /* SETUP_2FA */,
  ["TWO_FACTOR_DONE" /* TWO_FACTOR_DONE */]: void 0,
  ["LOGIN_DONE" /* LOGIN_DONE */]: void 0,
  ["ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */]: "LOGIN_DONE" /* LOGIN_DONE */,
  ["ADD_FUNDS_RECEIVE" /* ADD_FUNDS_RECEIVE */]: "LOGIN_DONE" /* LOGIN_DONE */,
  ["ADD_FUNDS_WITHDRAW" /* ADD_FUNDS_WITHDRAW */]: "LOGIN_DONE" /* LOGIN_DONE */,
  ["ADD_FUNDS_AWAITING" /* ADD_FUNDS_AWAITING */]: "ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */,
  ["ADD_FUNDS_SUCCESS" /* ADD_FUNDS_SUCCESS */]: void 0,
  ["ADD_FUNDS_FAILURE" /* ADD_FUNDS_FAILURE */]: void 0
};
const getStepHasFooter = (step) => {
  switch (step) {
    case "AUTH_MAIN" /* AUTH_MAIN */:
    case "AUTH_MORE" /* AUTH_MORE */:
    case "EX_WALLET_MORE" /* EX_WALLET_MORE */:
    case "EX_WALLET_SELECTED" /* EX_WALLET_SELECTED */:
    case "VERIFICATIONS" /* VERIFICATIONS */: {
      return true;
    }
    default: {
      return false;
    }
  }
};
function getAddFundsStep(currentTab) {
  switch (currentTab) {
    case "BUY":
      return "ADD_FUNDS_BUY" /* ADD_FUNDS_BUY */;
    case "RECEIVE":
      return "ADD_FUNDS_RECEIVE" /* ADD_FUNDS_RECEIVE */;
    case "WITHDRAW":
    default:
      return "ADD_FUNDS_WITHDRAW" /* ADD_FUNDS_WITHDRAW */;
  }
}
const IFrameSteps = ["PASSWORD_CREATION" /* PASSWORD_CREATION */];
export {
  AccountPreviousStep,
  IFrameSteps,
  LoginPreviousStep,
  ModalStep,
  RESET_TO_ACCOUNT_STEPS,
  RESET_TO_AUTH_STEPS,
  SignUpPreviousStep,
  getAddFundsStep,
  getStepHasFooter
};
